import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.866 5.864h7.566M3.866 8.645h5.41m-5.41 2.782h3.783m3.282 2.01.659.868a.377.377 0 0 0 .48.106.375.375 0 0 0 .133-.117l2.59-3.658m-.552-4.09v-2.61a.91.91 0 0 0-.285-.663L12.093 1.49a.956.956 0 0 0-.66-.264H1.945a.955.955 0 0 0-.669.272.918.918 0 0 0-.277.656v12.054c0 .246.1.482.277.656a.956.956 0 0 0 .669.271h5.26M17 12.273c0 2.41-1.976 4.363-4.414 4.363-2.438 0-4.414-1.953-4.414-4.363s1.976-4.364 4.414-4.364C15.024 7.91 17 9.863 17 12.273Z",
  stroke: "#0F6378",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }